import {BrowserCacheLocation, Configuration, PopupRequest, PublicClientApplication,} from "@azure/msal-browser";

const getRedirectUri = (): string => {
    if (window.location.hostname === "localhost") {
        return import.meta.env.VITE_AZURE_LOGIN_REDIRECT_LOCAL_URL as string;
    } 
    return `${import.meta.env.VITE_FRONTEND_BASE_URL}/login`;
};

const msalConfig: Configuration = {
    auth: {
        clientId: import.meta.env.VITE_AZURE_TOKEN_CLIENT_ID as string,
        authority: "https://login.microsoftonline.com/f1006ee5-f888-4308-92ea-fcaebe1c0b5e",
        redirectUri: getRedirectUri(),
        postLogoutRedirectUri: getRedirectUri(),
    },
    system: {
        iframeHashTimeout: 10_000,
        allowRedirectInIframe: true,
    },
    cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
    },
};


const msalInstance: PublicClientApplication = new PublicClientApplication(msalConfig);

export const loginRequest: PopupRequest = {
    scopes: [import.meta.env.VITE_AZURE_TOKEN_SCOPE as string],
};

const getMsalInstance = (): PublicClientApplication => msalInstance;

export default getMsalInstance;